/**
 * @generated SignedSource<<89b261ccdd476e391b47f91233ce26d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssemblyItemsQuery$variables = {
  skuId: string;
};
export type AssemblyItemsQuery$data = {
  readonly productSku: {
    readonly assemblyItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly required: boolean;
          readonly " $fragmentSpreads": FragmentRefs<"AssemblyItemsList_ProductSkuAssemblyItem">;
        };
      }>;
    };
  } | null;
};
export type AssemblyItemsQuery = {
  variables: AssemblyItemsQuery$variables;
  response: AssemblyItemsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skuId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "skuId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "required",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssemblyItemsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProductSku",
        "kind": "LinkedField",
        "name": "productSku",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductSkuAssemblyItemConnection",
            "kind": "LinkedField",
            "name": "assemblyItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductSkuAssemblyItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductSkuAssemblyItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AssemblyItemsList_ProductSkuAssemblyItem"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssemblyItemsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProductSku",
        "kind": "LinkedField",
        "name": "productSku",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductSkuAssemblyItemConnection",
            "kind": "LinkedField",
            "name": "assemblyItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductSkuAssemblyItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductSkuAssemblyItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductSkuAssemblyItemComposition",
                        "kind": "LinkedField",
                        "name": "composition",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minQuantity",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "maxQuantity",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductSkuAssemblyItemCompositionItemConnection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductSkuAssemblyItemCompositionItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductSkuAssemblyItemCompositionItem",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductSku",
                                        "kind": "LinkedField",
                                        "name": "sku",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductSkuSellerConnection",
                                            "kind": "LinkedField",
                                            "name": "sellers",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ProductSkuSellerEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Seller",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v4/*: any*/),
                                                      (v2/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v2/*: any*/),
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "name",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductSkuImageConnection",
                                            "kind": "LinkedField",
                                            "name": "images",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ProductSkuImageEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ProductSkuImage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "url",
                                                        "storageKey": null
                                                      },
                                                      (v2/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eefc0ef4c6471b10b54d7ebdc156d6a6",
    "id": null,
    "metadata": {},
    "name": "AssemblyItemsQuery",
    "operationKind": "query",
    "text": "query AssemblyItemsQuery(\n  $skuId: ID!\n) {\n  productSku(id: $skuId) {\n    assemblyItems {\n      edges {\n        node {\n          id\n          required\n          ...AssemblyItemsList_ProductSkuAssemblyItem\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AssemblyItemSelect_ProductSkuAssemblyItemCompositionItem on ProductSkuAssemblyItemCompositionItem {\n  sku {\n    _id\n    name\n    images {\n      edges {\n        node {\n          url\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AssemblyItemsListGroup_ProductSkuAssemblyItemComposition on ProductSkuAssemblyItemComposition {\n  minQuantity\n  maxQuantity\n  items {\n    edges {\n      node {\n        id\n        sku {\n          sellers {\n            edges {\n              node {\n                _id\n                id\n              }\n            }\n          }\n          id\n        }\n        ...AssemblyItemSelect_ProductSkuAssemblyItemCompositionItem\n      }\n    }\n  }\n}\n\nfragment AssemblyItemsList_ProductSkuAssemblyItem on ProductSkuAssemblyItem {\n  id\n  displayName\n  composition {\n    minQuantity\n    ...AssemblyItemsListGroup_ProductSkuAssemblyItemComposition\n  }\n}\n"
  }
};
})();

(node as any).hash = "462e1b34655e9b945d2f8ea644c8c8ca";

export default node;
